import type { ModuleManifest } from "./types";

export const salesOrderDetailsManifest: ModuleManifest = {
  name: "sales-order-details",
  label: "Sales Order Detail",
  labelPlural: "Sales Order Details",

  coreBOSModule: "cbSODetails",
  wsidPrefix: "64x",

  type: "standard",

  routes: {
    list: "/sales-order-details",
    show: "/sales-order-details/show/:id",
    create: "/sales-order-details/create",
    edit: "/sales-order-details/edit/:id",
  },

  navigation: {
    icon: "UnorderedListOutlined",
    order: 9,
    group: "Sales",
    hidden: true, // Detail modules are accessed via master, not directly
  },

  routing: {
    keywords: ["sales order detail", "order line", "order item", "so detail"],
    searchFields: ["cbsodetailno", "sodetail_code"],
    defaultSort: { field: "sequence_no", order: "asc" },
  },

  context: {
    supported: false,
  },

  fields: [
    { name: "cbsodetailno", label: "Detail No", type: "string", readonly: true },
    { name: "related_product", label: "Product", type: "reference", referenceModule: "Products", required: true },
    { name: "cbsomaster_relation", label: "Sales Order", type: "reference", referenceModule: "cbSOMaster", required: true },
    { name: "sodetail_code", label: "Code", type: "string" },
    { name: "unit_price", label: "Unit Price", type: "currency" },
    { name: "sodetail_rate", label: "Quantity", type: "number" },
    { name: "sodetail_condition", label: "Condition", type: "picklist" },
    { name: "related_pricebook", label: "Price Book", type: "reference", referenceModule: "PriceBooks" },
    { name: "sequence_no", label: "Sequence", type: "number" },
    { name: "net_price", label: "Net Price", type: "currency" },
    { name: "vat_tax", label: "VAT %", type: "number" },
    { name: "vat_value", label: "VAT Amount", type: "currency" },
    { name: "assigned_user_id", label: "Assigned To", type: "reference", referenceModule: "Users", hidden: true, defaultValue: "19x1" },
  ],

  relationships: [
    { module: "cbSOMaster", field: "cbsomaster_relation", label: "Sales Order", icon: "ShoppingCartOutlined", displayField: "subject" },
    { module: "Products", field: "related_product", label: "Product", icon: "ShoppingOutlined", displayField: "productname" },
  ],

  requiredFields: ["related_product", "cbsomaster_relation", "assigned_user_id"],

  massEdit: {
    enabled: false,
  },
};
